module.exports = __webpack_public_path__ + "static/media/audit_report_2018.ddcfa824.pdf";